import React from "react";
import moment from "moment";
import { message } from "antd";

import ScheduleView from "./ScheduleView";
import {
  saveClinicDoctorSchedule,
  saveDoctorDiscountedSchedule
} from "../../../services";
import {
  openNotificationWithIcon,
  strings,
  isSelectedDoctor
} from "../../../helpers";

const scheduleTimeFormat = "HH:mm";
const dailyArr = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export default class ScheduleContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scheduleId: "",
      isProcessing: false,
      doctorId: this.props.doctorsDetail.id,
      doctorTimings: [],
      dailyChecked: false,
      timezone: localStorage.getItem("clinic_timezone"),
      disableSave: false,
      checked: false,
      editingStarted: false,
      schedule: {
        days: [],
        start_time: "",
        end_time: "",
        timezone: localStorage.getItem("clinic_timezone"),
        discounted_fees: ""
      }
    };
    this.addUpdateCompRef = React.createRef();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.doctorsDetail &&
      nextProps.doctorsDetail.id !== prevState.doctorId
    ) {
      return {
        doctorId: nextProps.doctorsDetail.id
      };
    }
    return null;
  }

  /**
   * @function handleStartTimeSelect
   * @param time
   * @desc This function handles selecting start time
   */
  handleStartTimeSelect = time => {
    this.setState({
      ...this.state,
      schedule: {
        ...this.state.schedule,
        start_time: time
      }
    });
  };

  /**
   * @function handleEndTimeSelect
   * @param time
   * @desc This function handles selecting end time
   */
  handleEndTimeSelect = time => {
    this.setState({
      ...this.state,
      schedule: {
        ...this.state.schedule,
        end_time: time
      }
    });
  };

  /**
   * @function handleChangeFees
   * @desc This function handles selecting end time
   */
  handleChangeFees = e => {
    const { value } = e.target;
    this.setState({
      ...this.state,
      schedule: {
        ...this.state.schedule,
        discounted_fees: value
      }
    });
  };

  /**
   * @function getCheckedDays
   * @returns checkedDayNames
   * @desc This function gets the checked/ selected days
   */
  getCheckedDays = () => {
    let checkedDayNames = [];
    const checkedDays = document
      .getElementById(`addScheduleForm_${this.props.scheduleType}`)
      .getElementsByClassName("ant-tag-checkable-checked");
    for (let i = 0; i < checkedDays.length; i++) {
      checkedDayNames.push(checkedDays[i].getAttribute("selectValue"));
    }

    if (checkedDayNames.indexOf("Daily") > -1) {
      checkedDayNames = ["Daily"];
    }
    return checkedDayNames;
  };

  /**
   * @function checkDays
   * @param checkedDayNames
   * @desc This function handles checking days on UI
   */
  checkDays = checkedDayNames => {
    this.unCheckDays();
    const unCheckedDays = document
      .getElementById(`addScheduleForm_${this.props.scheduleType}`)
      .getElementsByClassName("ant-tag-checkable");
    if (checkedDayNames.length < 7) {
      for (let i = 0; i < unCheckedDays.length; i++) {
        if (
          checkedDayNames.indexOf(
            unCheckedDays[i].getAttribute("selectValue")
          ) > -1
        ) {
          unCheckedDays[i].classList.add("ant-tag-checkable-checked");
        }
      }
    } else {
      unCheckedDays[0].classList.add("ant-tag-checkable-checked");
    }
  };

  /**
   * @function unCheckDays
   * @desc This function handles unchecking days on UI
   */
  unCheckDays = () => {
    const unCheckedDays = document
      .getElementById(`addScheduleForm_${this.props.scheduleType}`)
      .getElementsByClassName("ant-tag-checkable");
    for (let i = 0; i < unCheckedDays.length; i++) {
      unCheckedDays[i].classList.remove("ant-tag-checkable-checked");
    }
  };

  /**
   * @function showErrors
   * @param checkedDayNames
   * @returns boolean
   * @desc This function handles add/ update timings validations
   */
  showErrors = checkedDayNames => {
    let isError = false;
    let timingOverlapExist = false;
    const { schedule } = this.state;
    const startTimeObj = moment(schedule.start_time).format("HH:mm");
    const endTimeObj = moment(schedule.end_time).format("HH:mm");

    if (checkedDayNames.length === 0) {
      isError = true;
      message.error("Please select days", 5);
    }
    if (schedule.start_time === "" || schedule.end_time === "") {
      isError = true;
      message.error("Please select time", 5);
    }

    if (schedule.start_time !== "" && schedule.end_time !== "") {
      if (startTimeObj === endTimeObj) {
        isError = true;
        message.error("Time not valid", 5);
      }
      // commenting the below stated condition, to throw error if start time is greater than end time
      // to handle timezone differences
      // if (endTimeObj < startTimeObj) {
      //   isError = true;
      //   message.error(strings.doctors.invalidTiming, 5);
      // }
      // check fees
      if (
        this.props.scheduleType === "discounted" &&
        schedule.discounted_fees === ""
      ) {
        isError = true;
        message.error("Enter consultation fees", 5);
      }

      timingOverlapExist = this.checkIfTimingsOverlap();
    }

    return isError || timingOverlapExist;
  };

  /**
   * @function checkIfDayExist
   * @param dayToBeSaved
   * @desc This function checks if a selected day already exist in the saved days,
   *  this helps whether there is some overlapping the selected timings or not
   */
  checkIfDayExist = dayToBeSaved => {
    let checkedDayNames = this.getCheckedDays();
    if (checkedDayNames.join(",") === "Daily") {
      checkedDayNames = dailyArr;
    }
    if (checkedDayNames.includes(dayToBeSaved)) {
      return true;
    }
  };

  /**
   * @function checkIfTimingsOverlap
   * @returns boolean
   * @desc This function checks if there is some overlapping the selected timings or not
   */
  checkIfTimingsOverlap = () => {
    const schedules =
      this.props.scheduleType && this.props.scheduleType === "regular"
        ? this.props.doctorsDetail.schedules
        : this.props.doctorsDetail.discount_schedule;
    const selectedSchedule = this.state.schedule;
    let timingOverlapExist = false;
    if (schedules.length === 0) {
      return timingOverlapExist;
    }
    schedules.some(schedule => {
      if (schedule.id === this.state.scheduleId) {
        // in case of editing, skip matching next steps
        // if selected schedule is same as schedule id in the list
        return false;
      }
      const isDayPresent = schedule.days.some(this.checkIfDayExist);

      if (isDayPresent) {
        let savedStartTime = `${moment(schedule.start_time).format("HH:mm")}`;
        // making a dummy date for comparison
        savedStartTime = new Date(`1/1/1999 ${savedStartTime}`);

        let savedEndTime = `${moment(schedule.end_time).format("HH:mm")}`;
        savedEndTime = new Date(`1/1/1999 ${savedEndTime}`);

        let selectedStartTime = `${moment(selectedSchedule.start_time).format(
          "HH:mm"
        )}`;
        selectedStartTime = new Date(`1/1/1999 ${selectedStartTime}`);

        let selectedEndTime = `${moment(selectedSchedule.end_time).format(
          "HH:mm"
        )}`;
        selectedEndTime = new Date(`1/1/1999 ${selectedEndTime}`);
        // for example savedStartTime= 08:00 am to savedEndTime= 10:00 pm
        const isSame =
          selectedStartTime.getTime() === savedStartTime.getTime() &&
          selectedEndTime.getTime() === savedEndTime.getTime();
        // isBetween for: 9:00 am to 11:00 am
        const isBetween =
          selectedStartTime > savedStartTime && selectedEndTime < savedEndTime;
        // afterStartTime: 9:00 am to 11:00pm
        const afterStartTime =
          selectedStartTime > savedStartTime &&
          selectedStartTime < savedEndTime &&
          selectedEndTime >= savedEndTime;
        // beforeStartTime: 6:00 am to 9: 00 am
        const beforeStartTime =
          selectedStartTime < savedStartTime &&
          selectedEndTime > savedStartTime;
        // 9 am to 9pm
        const equalToStartTime =
          selectedStartTime.getTime() === savedStartTime.getTime() &&
          selectedEndTime > savedStartTime &&
          selectedEndTime < savedEndTime;

        if (
          isSame ||
          isBetween ||
          afterStartTime ||
          beforeStartTime ||
          equalToStartTime
        ) {
          // show error that time is same
          message.error("Timings are overlapping", 5);
          timingOverlapExist = true;
        }
      }
    });
    return timingOverlapExist;
  };

  /**
   * @function saveSchedule
   * @desc This function handles add/ update schedule
   */
  saveSchedule = () => {
    message.destroy();
    const { clinicId } = this.props;
    const { doctorId, schedule, timezone, scheduleId } = this.state;
    const checkedDayNames = this.getCheckedDays();
    const isError = this.showErrors(checkedDayNames);

    if (!isError) {
      const schedule_details = schedule;
      schedule_details.days =
        checkedDayNames.join(",") === "Daily" ? dailyArr : checkedDayNames;
      schedule_details.timezone = timezone;
      schedule_details.start_time = moment(schedule_details.start_time)
        .utc()
        .format(scheduleTimeFormat);
      schedule_details.end_time = moment(schedule_details.end_time)
        .utc()
        .format(scheduleTimeFormat);

      schedule_details.scheduleId = scheduleId ? scheduleId : "";
      const scheduleDetails = {
        schedule_details
      };
      let result = null;

      result = saveClinicDoctorSchedule(doctorId, scheduleDetails, clinicId);
      // if (this.props.scheduleType === "regular") {
      //   // save regular scheule
      //   result = saveDoctorSchedule(doctorId, scheduleDetails);
      // } else {
      //   // save discounted schedule
      //   result = saveDoctorDiscountedSchedule(doctorId, scheduleDetails);
      // }
      result.then(response => {
        if (response.data && response.data.success) {
          if (this.props.scheduleType === "regular") {
          } else {
            if (!scheduleId) {
              // trackMixpanelEvent("Added_Doctor_discounted_timings");
            }
          }
          openNotificationWithIcon(
            "success",
            "Schedule info",
            `Added successfully`
          );
          this.cancelSave();
          this.props.getDetail();
        } else {
          openNotificationWithIcon("error", "Schedule info", "Server error");
        }
      });
    }
  };

  /**
   * @function handleDailyChange
   * @param checked
   * @desc This function handles checking dailyChecked "Daily" marker
   */
  handleDailyChange = checked => {
    this.setState({ dailyChecked: checked });
    const unCheckedDays = document
      .getElementById(`addScheduleForm_${this.props.scheduleType}`)
      .getElementsByClassName("ant-tag-checkable");
    if (!checked) {
      unCheckedDays[0].classList.remove("ant-tag-checkable-checked");
    } else {
      for (let i = 0; i < unCheckedDays.length; i++) {
        unCheckedDays[i].classList.remove("ant-tag-checkable-checked");
      }
    }
  };

  /**
   * @function cancelSave
   * @desc This function handles resetting add schedule form
   */
  cancelSave = () => {
    this.setState({
      dailyChecked: false,
      scheduleId: "",
      schedule: {
        days: [],
        start_time: "",
        end_time: ""
      }
    });
    this.unCheckDays();
  };

  /**
   * @function handleEdit
   * @desc This function handles setting values in schedule form, for editing
   */
  handleEdit = scheduleObj => {
    const checkedDayNames = scheduleObj.days;

    this.setState({
      editingStarted: true,
      dailyChecked: checkedDayNames.indexOf("Daily") > -1 ? true : false,
      scheduleId: scheduleObj.id,
      schedule: {
        start_time: moment(scheduleObj.start_time),
        end_time: moment(scheduleObj.end_time),
        timezone: scheduleObj.timezone,
        days: scheduleObj.days,
        discounted_fees: scheduleObj.discounted_fees
      }
    });
    setTimeout(() => {
      this.setState({
        editingStarted: false
      });
    }, 3000);
    this.checkDays(checkedDayNames);
  };

  render() {
    const { doctorsDetail, getDetail, scheduleType, fromSettings } = this.props;
    const {
      isProcessing,
      schedule,
      dailyChecked,
      disableSave,
      scheduleId,
      editingStarted
    } = this.state;

    return (
      <div className="with-box-shadow mb-20">
        <div className="table-with-search pb-10">
          {!fromSettings && (
            <h4 className="header-title">
              {scheduleType && scheduleType === "regular"
                ? "Clinic Timings"
                : "Discounted timings"}
            </h4>
          )}
        </div>
        <ScheduleView
          doctorsDetail={doctorsDetail}
          isProcessing={isProcessing}
          handleStartTimeSelect={this.handleStartTimeSelect}
          handleEndTimeSelect={this.handleEndTimeSelect}
          schedule={schedule}
          handleDailyChange={this.handleDailyChange}
          dailyChecked={dailyChecked}
          saveSchedule={this.saveSchedule}
          cancelSave={this.cancelSave}
          disableSave={disableSave}
          handleEdit={this.handleEdit}
          scheduleId={scheduleId}
          getDetail={getDetail}
          scheduleType={scheduleType}
          handleChangeFees={this.handleChangeFees}
          addUpdateCompRef={this.addUpdateCompRef}
          editingStarted={editingStarted}
        />
      </div>
    );
  }
}
